module.exports = __webpack_public_path__ + "img/1274020794.46de6c42.jpg";